import { Bubble, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { ChatbotServicesData } from './ChatbotServices.data';
import {
  StyledStack,
  BubbleWrapper,
  StyledSection,
  StyledHeadline,
  StyledServiceHedline,
  SingleServiceWrapper,
  StyledServicesWrapper,
  SectionNameBannerStack,
  StyledServiceDescription,
} from './styles';

export const ChatbotServices = ({ ...props }) => {
  const services = ChatbotServicesData().servicesData;

  return (
    <StyledSection width="normal">
      <StyledStack {...props}>
        <SectionNameBannerStack>
          <NameBanner type="section" text="Services" color="magenta" />
        </SectionNameBannerStack>
        <StyledHeadline
          display={{ xs: 'none', md: 'block' }}
          variant="display_md"
          paragraph>
          AI chatbot <br />
          development
          <br /> services by <br />
          Rumble Fish
        </StyledHeadline>
        <StyledHeadline
          display={{ xs: 'block', md: 'none' }}
          variant="display_md"
          paragraph>
          AI chatbot development services by Rumble Fish
        </StyledHeadline>

        <StyledServicesWrapper>
          {services.map((el, index) => (
            <SingleServiceWrapper key={index}>
              <BubbleWrapper>
                <Bubble
                  params={{
                    name: `aiService_${el.name}`,
                    icon: el.icon,
                    top: 0,
                    left: 0,
                    size: 100,
                    boxShadow: el.boxShadow,
                    floatingY: el.floatingY,
                    duration: el.duration,
                  }}
                />
              </BubbleWrapper>
              <StyledServiceHedline variant="strong_500">
                {el.title}
              </StyledServiceHedline>

              <StyledServiceDescription variant="regular_400">
                {el.description}
              </StyledServiceDescription>
            </SingleServiceWrapper>
          ))}
        </StyledServicesWrapper>
      </StyledStack>
    </StyledSection>
  );
};
